import { EpimsBaseEntityDto } from './epim-base.dto';
export class AuditTrayDto extends EpimsBaseEntityDto {
  
     ActionedBy: string;
     ActionDate: string;
     ActionTime: Date;
     ActionModule: string;
     ActionActivity: string;
     StaffId: string;
     ActionDescription: string;
     ActionAmount: number;
     AuditActivity: string;
    SubscriptionUserId: string;  
    Version: number;
}
